import React, {Component} from 'react';
import { Redirect,Link,history } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class AddTicket extends Component {
    constructor(){
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data?this.decrypt(localStorage.getItem('encdata'), 0):'';
        this.state = {
            message:'',
            owners:[],
            app:[],
            studio:[],
            account_manager:[],
            title:'',
            description:'',
            helpdesk_id:'',
            type:'Bug',
            appname:'0',
            priorty:'Medium',
            studio_email:'',
            eta:'',
            status:'Open',
            assigned_to:'128',
            escalation_level:'L1',
            ticket_email_cc:'',
            account_managerinse:'',
            project:'',
                userName:has_local_data?localdata.user_name:'',
                userAuthKey:has_local_data?localdata.user_key:'',
                apiUrl:this.decryptconfigdata('apiUrl'),
                userId:has_local_data?localdata.user_id:'',
            fields: {},
            errors: {},
            //startDate:'',
            error_message:'',
            checkBox: true,
            setdefault: ''
        }
        this.insertTicket = this.insertTicket.bind(this);
        this.onChange = this.onChange.bind(this);
        this.handleChangeDate = this.handleChangeDate.bind(this);
        this.tick = this.tick.bind(this);
}
decryptconfigdata(configkey){
var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
        iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
}
    
decrypt(findresponse, flg){
var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
        iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
     rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    goBack() {
        window.history.back();
    }
    handleValidation(){
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.fields);
        //Name
        if (!fields["title"]){
           formIsValid = false;
           errors["title"] = "This field is required.";
        }
if (!fields["description"]){
            formIsValid = false;
            errors["description"] = "This field is required.";
         }
if (!fields["studio_email"]){
            formIsValid = false;
            errors["studio_email"] = "This field is required.";
         }
if (fields["dev_hours"] && !this.isValidNumber(fields["dev_hours"])){
            formIsValid = false;
            errors["dev_hours"] = "Please Provide Numbers Only.";
        }
if (fields["ticket_email_cc"] && !this.isValidEmail(fields["ticket_email_cc"])){
formIsValid = false;
        errors["ticket_email_cc"] = "Please Provide emails Only.";
}
   
       this.setState({errors: errors});
       return formIsValid;
   }
    fileSelecthandler = (event) => {
        this.setState({selectedFile:event.target.files[0]});
      }
    insertTicket(e){ 
        //e.preventDefault();
if (this.handleValidation()){
            console.log("Data Has been submitted");
            //return true;
} else{
            console.log("This Fields Are required.")
            return false;
         }
document.getElementById("add_ticket").innerHTML = "Sending....";
        let img = document.getElementById('files').files.length;
        const fd = new FormData;
        if (img > 0){
       for (var x = 0; x < img; x++) {
            fd.append("image[]", document.getElementById('files').files[x]);
        }
       }
               
        document.getElementById("add_ticket").disabled = true;
        fd.append('ticket_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/TicketRest/InsertTicket/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
        .then((Response) => Response.json())
        .then((findresponse) =>
        {
        findresponse = this.rawjsonparse(findresponse, 1);
               // console.log(findresponse) ;
                document.getElementById("add_ticket").innerHTML = "Submit";
                if (findresponse.code == 200){
                    this.setState({ message: findresponse.msg }, function() {
                      //window.location.href='/tickets/'; 
                      this.props.history.push('/tickets/');
                     }); 
                } else {
                
                    this.setState({message:findresponse.msg});
                    document.getElementById("add_ticket").disabled = false;
                }
              
        }) 
    }
    isValidNumber(number) {
		var pattern = /^[0-9]+$/;
		return pattern.test(number);
		}
isValidEmail(email) {
var pattern = /^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(,[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/;
        return pattern.test(email);
}
    onChange(event){
        let fields = this.state.fields;
        this.setState({[event.target.name]: event.target.value});
        fields[event.target.name] = event.target.value;        
        this.setState({fields});
         //console.log({[event.target.name]: event.target.value});
      }
      handleCheck(event){
        this.setState({[event.target.name]: event.target.value});
      }
      handleChangeDate(date) {
        this.setState({
          startDate: date,
          etaDate:moment(date).format("YYYY-MM-D")
}, function(){
            console.log(this.state.etaDate);
        });
      }
      ticketsList() {
fetch(this.state.apiUrl + '/TicketRest/Adddetails/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
                .then((Response) => Response.json())
                .then((findresponse) =>
                {
        findresponse = this.rawjsonparse(findresponse, 1);
                    this.setState({
                        app: findresponse.app,
                        owners: findresponse.owner,
                       studio: findresponse.studio,
                       account_manager: findresponse.account_manager
                 
                    })
                

                })
    }
    tick() {
        this.setState({
          checkBox: !this.state.checkBox
        })
    
        this.state.checkBox ? this.setState({ setdefault: '1' }) : this.setState({ setdefault: '' })
    
      }

    componentDidMount()
    {
        this.setState({ title: 'About Us' });
        if (!localStorage.getItem('userLogin')){
            this.setState({redirect:true});
          }
        document.title = "Intranet | Add Ticket";
        this.ticketsList();
        $(document).ready(function () {
        if (window.File && window.FileList && window.FileReader) {
        $("#files").on("change", function(e) {
            var fi = document.getElementById('files');
            var files = e.target.files,
            filesLength = files.length;
        });
        } else {
            alert("Your browser doesn't support to File API")
        }
        });
        $('.upload_btn label').click(function(){
            $('.upload_btn .inputfile').click();
        });
        $('.inputfile').each(function()
	{
var $input = $(this),
        $label = $input.next('label'),
			labelVal = $label.html();
        $input.on('change', function(e)
		{
			var fileName = '';
                if (this.files && this.files.length > 1)
                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                else if (e.target.value)
                fileName = e.target.value.split('\\').pop();
                if (fileName)
                $label.find('span').html(fileName);
			else
                $label.html(labelVal);
		});
		// Firefox bug fix
		$input
        .on('focus', function(){ $input.addClass('has-focus'); })
        .on('blur', function(){ $input.removeClass('has-focus'); });
	});
    }
    render(){
if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
          }
         
        return(
        <div >
            <Header brecum_name="Support" brecum_page="Add Ticket"/>
        
        <div class="right_col">
            <span className="error">{this.state.error_message}</span>
                
        		<div class="intranet_body">
                <div class="title mob"><HeaderMob page_name="Add Ticket"/></div>
				<div class="top-row-form">
					<div class="form-group">
					  <label for="title">Title<span class="star">*</span></label>
					  <input type="text" name="title"  id="title" className="form-control" onChange={this.onChange} />
                      <span class="error">{this.state.errors["title"]}</span>
                    </div>
					<div class="form-group">
					  <label>Descriptions<span class="star">*</span></label>
					  <textarea class="form-control" name="description" id="description" onChange={this.onChange}></textarea>
                      <span class="error">{this.state.errors["description"]}</span>
                    </div>
				</div>
				<div class="form-section add row">
					<div class="form-group col-sm-3 col-xs-12">
						<label>#ER</label>
						<input type="text" name="helpdesk_id"  className="form-control" onChange={this.onChange} />
						<span class="note">Add Er separated by comma(,)</span>
					</div>
					<div class="form-group col-sm-3 col-xs-6">
						<label>Type</label>
						<div class="filter">
                            <select  class="form-control" id="type" name="type"  onChange={this.onChange}>
                                {/* <option value='all' selected > All</option> */}
                                <option value="Bug">Bug</option>
                                <option value="New Feature">New Feature</option>
                                <option value="How To">How To</option>
                                <option value="SetupMigration">Setup/Migration</option>
                            </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
					<div class="form-group col-sm-3 col-xs-6">
						<label>App</label>
						<div class="filter">
                            <select  id="appname" class="form-control" name="appname" onChange={this.onChange} >
                                {
        this.state.app.map((dynamicData, key) =>
                                <option value={dynamicData.app_id}>{dynamicData.app_name}</option>
                                    )
                                }
                            </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
					<div class="form-group col-sm-3 col-xs-6">
						<label>Priority</label>
						<div class="filter">
                            <select class="form-control" name="priorty" id="priorty"  onChange={this.onChange} >
                                <option value="Critical">Critical</option>
                                <option value="High">High</option>
                                <option value="Medium" selected>Medium</option>
                                <option value="Low">Low</option>
                                {/* <option value="all" >All</option> */}
                            </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
					<div class="form-group col-sm-3 col-xs-6">
						<label>Customer(Studio)<span class="star">*</span></label>
						<div class="filter">
                            <select  id="studio_email" class="form-control" name="studio_email" onChange={this.onChange} >
                                <option value='all' selected > All</option>
                                {
        this.state.studio.map((dynamicData, key) =>
                                <option value={dynamicData.email}>{dynamicData.name}</option>
                                    )
                                }
                            </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
                        </div>
                        <span class="error">{this.state.errors["studio_email"]}</span>
					</div>
					<div class="form-group col-sm-3 col-xs-6 icon-live icon-date">
                    <label>Eta</label>
                    <DatePicker
                    readOnly={true}
                    selected={this.state.startDate}
                    onChange={this.handleChangeDate}
                    minDate={moment()}
                    placeholderText="Select a date"
                    />
                    <i class="fa fa-calendar" aria-hidden="true"></i>

                    
                    {/* <DatePicker
                    selected={this.state.startDate}
                    onChange={this.handleChangeDate}
                    showTimeSelect
                    dateFormat="LLL" /> */}
					</div>
					<div class="form-group col-sm-3 col-xs-6">
						<label>Status</label>
						<div class="filter">
                            <select class="form-control" name="status" id="status"  onChange={this.onChange} >
                                <option value="Open" selected>Open</option>
                                <option value="Closed">Closed</option>
                                <option value="Re-opened">Re-opened</option>
                                
                            </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
					<div class="form-group col-sm-3 col-xs-12">
						<label>Owner</label>
						<div class="filter">
                            <select  id="assigned_to" class="form-control" name="assigned_to" onChange={this.onChange} >
                            <option value='all' selected="selected">Support</option>
                                {
        this.state.owners.map((dynamicData, key) =>
                                <option value={dynamicData.id}>{dynamicData.name}</option>
                                    )
                                }
                            </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
					<div class="form-group col-sm-3 col-xs-12">
						<label>Cc</label>
                    <textarea class="form-control" name="ticket_email_cc"  id="email_cc_feature" onChange={this.onChange} ></textarea>
                    <span class="note ticket_cc_note">Add emails with separated by comma (,)</span>
                     <span className="error">{this.state.errors["ticket_email_cc"]}</span>
					</div>
					<div class="form-group col-sm-3 col-xs-6">
						<label>Escaltion Level</label>
						<div class="filter">
                        <select class="form-control" id="escalation_level" name="escalation_level" onChange={this.onChange}>
                        <option value="L1" selected="selected">L1</option>
                        <option value="L2">L2</option>
                        <option value="L3">L3</option>
                        <option value="L4">L4</option>
                        <option value="L5">L5</option> 
                        <option value="L6">L6</option> 
                        <option value="L7">L7</option> 
                        </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
					<div class="form-group col-sm-3 col-xs-6">
						<label>Account Manager</label>
						<div class="filter">
                            <select  class="form-control" id="account_managerinse" name="account_managerinse"  onChange={this.onChange} disabled>
                                <option value='all' selected > All</option>
                                {
        this.state.account_manager.map((dynamicData, key) =>
                                <option value={dynamicData.id}>{dynamicData.name}</option>
                                    )
                                }
                            </select>
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</div>
					</div>
                <div class="form-group col-sm-3 col-xs-6">
                <label>Dev Hour(s)</label>
                <input type="text" name="dev_hours"  className="form-control" onChange={this.onChange}/>
                <span className="error">{this.state.errors["dev_hours"]}</span>
                </div>
               </div>
               <div className="row">
                <div class="radio feature-check">
                        <input class="valid_fld" id="2" type="checkbox" onClick={this.tick} defaultChecked={this.state.check}/>
                        <label for="2">
                            <span></span>
                            Project
                        </label>
                </div>
                </div>
                <div class="upload">
                <label>Add Attachment :</label>
					<div class="upload_btn">
						<input type="file" name="file-1[]" id="files" class="inputfile inputfile-1" data-multiple-caption="{count} files selected" multiple/>
						<label for="file-1">
							<i class="fa fa-plus hidden-sm" aria-hidden="true"></i>
							<span>Choose file</span>
							<i class="fa fa-cloud-upload-alt hidden-md" aria-hidden="true"></i>
						</label>
					</div>
                                        <span className="error">{this.state.message}</span>
				</div>
            <button type="submit" name="add_ticket" id="add_ticket" class="btn btn-sky mob-btn" onClick={() => this.insertTicket()}>Submit</button>
			</div>
            </div>

            </div>
        )
    }
}
export default AddTicket;



// WEBPACK FOOTER //
// ./src/components/support/AddTicket.js